import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Badge } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/HR_Managment/Job_Role/AddJobRole';
import EditJobRole from '../../../../modal/Settings/HR_Managment/Job_Role/EditJobRole';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Job_Role = () => {
    const tableRef = useRef(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [open, setOpen] = useState(false); // Modal visibility state
    const [modalType, setModalType] = useState("");
    const handleModalToggle = () => {
        setModalType("Add");  // Set the modal type to "Add"
        setOpen(true);  // Toggle the modal visibility
    };

    const [jobroles, setJobRoles] = useState([]);
    const [editModalShow, setEditModalShow] = useState(false);
    const [currentItemId, setCurrentJobRolesId] = useState(null);
    const [hasFetched, setHasFetched] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');

    const handleModalJobRoles_Edit = (id) => {
        setCurrentJobRolesId(id);
        setEditModalShow(true);

    };

    const DeleteModal = (jobroleId, jobroleName) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to delete this Department.
                </div>
                <p class="text-center"><b>${jobroleName}</b></p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${baseURL}/jobrole/${jobroleId}`)
                    .then(() => {
                        toast.success("Jobrole Deleted Successfully");
                        fetchJobRoles(); 
                    })
                    .catch(error => {
                        console.error("Delete failed:", error);
                        toast.error("Jobrole Deletion Failed");
                    });
            }
        });
    };

    const fetchJobRoles = () => {
        const params = {
            page,
            per_page: perPage,
            search: searchTerm,
        };

        axios.get(`${baseURL}/jobrole`, { params })
            .then(response => {
                const res = response.data;

                // Extract job roles array safely
                const jobRoleList = Array.isArray(res.data) ? res.data : (Array.isArray(res) ? res : []);

                // Extract pagination info, fallback to defaults
                const lastPage = res.pagination?.last_page || 1;
                const total = res.pagination?.total || jobRoleList.length;

                setJobRoles(jobRoleList);
                setTotalPages(lastPage);
                setTotalCount(total);
                setHasFetched(true);
            })
            .catch(error => {
                console.error("Error fetching roles:", error);
                setJobRoles([]);
                setTotalPages(1);
                setTotalCount(0);
                setHasFetched(true);
            });
    };

    useEffect(() => {
        console.log("Job roles data:", jobroles);
        fetchJobRoles();
    }, [page, perPage, searchTerm]);

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [jobroles]);

    const handleStatusChange = (jobroleId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.put(`${baseURL}/jobrole/status/${jobroleId}`, { status: newStatus })
            .then(() => {
                toast.success("Status Updated Successfully!");
            })
            .catch(error => {
                toast.error("Status Updation Failed");
                console.log("Error updating status:", error);
            });
    };

    return (
        <>

            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Job Role</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">HR Management</li>
                    </ol>
                </div>
                <Button
                    className="btn btn-primary btn-sm"
                    onClick={handleModalToggle}
                >
                    <span className="me-2">
                        <i className="fa-solid fa-plus fs-8"></i>
                    </span>
                    <span>Add Job Role</span>
                </Button>
                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} refresh={fetchJobRoles} />
                )}
                <EditJobRole
                    show={editModalShow}
                    onClose={() => setEditModalShow(false)}
                    jobroleId={currentItemId}
                    onUpdated={fetchJobRoles}
                />
            </div>

            <div className="table-container">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{ fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{ fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>

                <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-50px text-start'>S.No</th>
                            <th className='min-w-150px'>Department</th>
                            <th className='min-w-150px'>Job Role</th>
                            <th className='min-w-300px'>Description</th>
                            <th className='min-w-100px'>Status</th>
                            <th className='min-w-100px'>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {jobroles.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="7" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                                {jobroles.map((jobroles, idx) => (
                                    <tr key={jobroles.sno}>
                                        <td className='text-start'>
                                            <label className='text-black font-w400 fs-7'>{idx + 1}</label>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{jobroles.dept_name}</label>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{jobroles.jobrole_name}</label>
                                        </td>
                                        <td>
                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{jobroles.description || "No description available."}</span></Tooltip>} >
                                                <div className='text-truncate mw-400px text-black font-w400 fs-7'>{jobroles.description || "No description available."}</div>
                                            </OverlayTrigger>
                                        </td>
                                        <td>

                                            <div className="form-check form-switch d-flex align-items-center mb-3">
                                                <input
                                                    className="form-check-input me-2"
                                                    type="checkbox"
                                                    role="switch"
                                                    checked={jobroles.status == 0}
                                                    onChange={() => handleStatusChange(jobroles.sno, jobroles.status)}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <span class="text-end">
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>}>
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalJobRoles_Edit(jobroles.sno)}>
                                                        <i className="fa-solid fa-pen-to-square fs-6"></i>
                                                    </Button>
                                                </OverlayTrigger>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>}>
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => DeleteModal(jobroles.sno, jobroles.jobrole_name)}>
                                                        <i className="fa-solid fa-trash-can fs-6 mt-1"></i>
                                                    </Button>
                                                </OverlayTrigger>
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {jobroles.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + jobroles.length} of {TotalCount} entries
                            </span>
                        ) : (
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>

            </div>
        </>
    )


}
export default Job_Role;